const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/

export const mobileDigits = (raw: string): string => {
    let digits = raw.replace(/\D/g, '')

    if (digits.length > 10 && digits.startsWith('91')) digits = digits.slice(2)
    if (digits.length > 10 && digits.startsWith('0')) digits = digits.slice(1)

    return digits.slice(0, 10)
}

export const formatMobile = (raw: string): string => {
    const digits = mobileDigits(raw)

    return digits.length > 5 ? `${digits.slice(0, 5)} ${digits.slice(5)}` : digits
}

export const isValidMobile = (raw: string): boolean => /^[6-9]\d{9}$/.test(mobileDigits(raw))

export const isValidEmail = (raw: string): boolean => EMAIL_PATTERN.test(raw.trim())
